// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — time-picker.styled.classic.js, новая — time-picker.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './time-picker.styled.classic';
import * as cp from './time-picker.styled.cp';

export const Back = isCp ? cp.Back : classic.Back;
export const Content = isCp ? cp.Content : classic.Content;
export const Modal = isCp ? cp.Modal : classic.Modal;
